import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4f1948d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "case"
};
const _hoisted_2 = {
  class: "title fadeInUp",
  wait: "500"
};
const _hoisted_3 = {
  class: "case-container fadeInUp"
};
const _hoisted_4 = {
  class: "case-list"
};
const _hoisted_5 = {
  class: "pic"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "case-cont"
};
const _hoisted_8 = {
  class: "case-name"
};
const _hoisted_9 = {
  class: "case-img"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "case-desc"
};
import { SwiperSlide } from 'swiper/vue';
import { isMobile } from '@/utils';
export default {
  __name: 'index',
  props: {
    head: {
      type: String,
      default: '客户案例'
    }
  },
  setup(__props) {
    const props = __props;
    const data = [{
      imgSrc: require('@/assets/img/inspect.jpg'),
      sign: require('@/assets/img/inspect-sign.jpg'),
      title: '数字化未来',
      desc: '重庆检察院远程提讯获关注'
    }, {
      imgSrc: require('@/assets/img/bank.jpg'),
      sign: require('@/assets/img/bank-sign.jpg'),
      title: '创新笔迹识别',
      desc: '农商行身份认证新突破'
    }, {
      imgSrc: require('@/assets/img/gas.jpg'),
      sign: require('@/assets/img/gas-sign.jpg'),
      title: '降本数字转型',
      desc: '华润燃气去纸化高效流转'
    }, {
      imgSrc: require('@/assets/img/vanke.jpg'),
      sign: require('@/assets/img/vanke-sign.jpg'),
      title: '电子签小切口',
      desc: '看万科如何实现业务增长'
    }];
    const getStyle = i => {
      return {
        'animation-duration': `.5s`
      };
    };
    const _isMobile = isMobile();
    const slidesPerView = _isMobile ? 'auto' : 4;
    return (_ctx, _cache) => {
      const _component_rotation = _resolveComponent("rotation");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(props.head), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_rotation, {
        slidesPerView: _unref(slidesPerView),
        autoplay: false,
        navigation: false
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(data, (item, index) => {
          return _createVNode(_unref(SwiperSlide), {
            class: "case_item",
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "case-item",
              style: _normalizeStyle(getStyle(index))
            }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
              src: item.imgSrc
            }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
              src: item.sign
            }, null, 8, _hoisted_10)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, _toDisplayString(item.title), 1), _createElementVNode("p", null, _toDisplayString(item.desc), 1)])])], 4)]),
            _: 2
          }, 1024);
        }), 64))]),
        _: 1
      }, 8, ["slidesPerView"])])])]);
    };
  }
};